import { BatchUpdateAssignmentInput } from "@/models";
import graphqlRequest from "../../assignmentRequest";

const UPDATE_ASSIGNMENT_GQL = `mutation updateAssignment($input: [BatchUpdateAssignmentInput!]!) {
    batchUpdateAssignment(input: $input) {
      lessonPlanId
      assignmentId
      dateTo
      dateFrom
      entityId
      entityType
      grade
      status
      clpId
      parentId
      assignor
      assignmentType
      assignmentCategory
      manifest {
        storyId
        activityType
        status
        contentTags
        locale
        sequence
        skills {
          skillId
          unitName
          order
          lessonName
          isRepeated
        }
      }
      resources
    }
  }`;

export async function updateAssignmentMutation(updateAssignmentInputs: BatchUpdateAssignmentInput[]) {
  return await graphqlRequest(UPDATE_ASSIGNMENT_GQL, { input: updateAssignmentInputs });
}
